define("shared/components/shared/linkinbio/modal/multi-link", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "later/utils/compare-strings", "later/utils/is-valid-url", "shared/utils/constants/linkinbio-block-types", "shared/utils/image-tag", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _tracking, _compareStrings, _isValidUrl, _linkinbioBlockTypes, _imageTag, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/compare-strings",0,"later/utils/is-valid-url",0,"shared/utils/constants/linkinbio-block-types",0,"shared/utils/image-tag",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{this.clickOutside}}
    @focusTrap={{true}}
    data-test-id="linkinbio-multi-link-modal"
    {{did-insert this.setup}}
    as |modal|
  >
    <modal.card class="cDT--modal">
  
      <div class="cDT--modal__mediaWrapper">
        <div class="cDT--modal__mediaMobileHeader u--hide--desktop">
          <p class="o--modalHeader__title">
            {{t "linkinbio.multi_link.external_links"}}
          </p>
        </div>
        <div class="cTG--tagWrapper eLB--modal__image">
          <img
            class="o--media cDT--modal__media"
            data-test-id="image"
            src={{if
              @post.firstPostMediaItem.previewUrl
              @post.firstPostMediaItem.previewUrl
              this.linkinbioPost.highResOrProcessingUrl
            }}
          />
        </div>
      </div>
  
      {{#if this.editingLink}}
        <div class="cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0">
          <modal.card-header class="u--p__tb__md cLB--header">
            {{! Back Arrow }}
            <div class="u--m__r">
              {{#if this.addNewLink}}
                <Shared::Ui::Button @onClick={{this.cancelAddLink}} @variant="unstyled">
                  {{svg-jar "arrow-left" class="o--icon--md o--icon--hl u--m__t__sm qa--linkinbio_left_arrow"}}
                </Shared::Ui::Button>
              {{else}}
                <Shared::Ui::Button @onClick={{this.cancelEditLink}} @variant="unstyled">
                  {{svg-jar "arrow-left" class="o--icon--md o--icon--hl u--m__t__sm qa--linkinbio_left_arrow"}}
                </Shared::Ui::Button>
              {{/if}}
            </div>
            <div class="cLB--header__title">
              {{! Title }}
              <h4 class="o--modalHeader__title">
                {{#if this.addNewLink}}
                  {{t "linkinbio.multi_link.add_link"}}
                {{else}}
                  {{t "linkinbio.multi_link.edit_link"}}
                {{/if}}
              </h4>
              {{! Subtitle }}
              <span class="cLB--header__subtitle u--text--sm u--m__t__0">
                {{t "linkinbio.multi_link.adjust_location"}}
              </span>
            </div>
          </modal.card-header>
  
          <section class="o--modalBody--secondary has--footer" {{perfect-scroll}}>
            <div class="o--formWrapper">
              <label>
                {{t "linkinbio.multi_link.link_title"}}
              </label>
              <Input
                @type="text"
                @value={{this.selectedLink.title}}
                class="o--form__input qa--linkinbio_text_input"
                placeholder={{t "linkinbio.multi_link.link_title"}}
                required={{true}}
              />
            </div>
            <div class="o--formWrapper">
              <label>
                {{t "linkinbio.multi_link.link_url"}}
              </label>
              <Input
                @type="text"
                @value={{this.selectedLink.linkUrl}}
                class="o--form__input qa--linkinbio_url_input"
                data-test-id="qa--linkinbio_url_input"
                placeholder={{t "linkinbio.multi_link.link_url"}}
                required={{true}}
              />
            </div>
          </section>
  
          <modal.card-footer>
            {{#if this.addNewLink}}
              <button
                class="o--btn o--btn--outline o--btn--block qa--linkinbio_add_link
                  {{if this.isValidMultiLink '' 'o--btn--disabled'}}"
                type="button"
                {{on "click" (fn this.commitPoint this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.save_link"}}
              </button>
            {{else}}
              <button
                class="o--btn o--btn--mute u--float--left"
                type="button"
                {{on "click" (fn this.toggleDeleteLink this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.remove_link"}}
              </button>
              <button
                class="o--btn o--btn--outline u--float--right {{if this.isValidMultiLink '' 'o--btn--disabled'}}"
                type="button"
                {{on "click" (fn this.commitPoint this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.update_link"}}
              </button>
            {{/if}}
          </modal.card-footer>
        </div>
      {{else}}
        <div class="cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0">
          <div class="o--modalHeader u--p__t__md u--hide--mobile">
            <p class="o--modalHeader__title u--float--left">
              {{t "linkinbio.multi_link.external_links"}}
            </p>
          </div>
          <span class="u--hide--desktop">
            <div class="o--modalHeader u--p__t__md">
              <p class="u--text--md u--text--bold">{{t "post.body.manage_multi_links"}}</p>
            </div>
          </span>
          <Shared::Linkinbio::List::MultiLink
            @addLink={{this.addLink}}
            @canAddNewLink={{this.canAddNewLink}}
            @editLink={{this.editLink}}
            @links={{this.sortedLinks}}
            @toggleDeleteLink={{this.toggleDeleteLink}}
          />
  
          <modal.card-footer>
            {{#if @handleSave}}
              <Shared::Ui::Button
                @additional="block"
                @isDisabled={{this.isLoading}}
                @onClick={{this.closeModalWithSave}}
                @text={{t "shared_phrases.save_changes"}}
                @variant="primary"
                class="qa--multiLink_saveBtn"
                data-test-id="multiLink-closeModalBtn"
              />
            {{else}}
              <Shared::Ui::Button
                @additional="block"
                @onClick={{fn this.closeModal false}}
                @text={{t "shared_words.done"}}
                @variant="outline"
                class="qa--multiLink_doneBtn"
                data-test-id="multiLink-closeModalBtn"
              />
            {{/if}}
          </modal.card-footer>
        </div>
      {{/if}}
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "FUkv1ScQ",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"linkinbio-multi-link-modal\"],[4,[38,1],[[30,0,[\"setup\"]]],null]],[[\"@close\",\"@focusTrap\"],[[30,0,[\"clickOutside\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"cDT--modal\"]],null,[[\"default\"],[[[[1,\"\\n\\n    \"],[10,0],[14,0,\"cDT--modal__mediaWrapper\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cDT--modal__mediaMobileHeader u--hide--desktop\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"linkinbio.multi_link.external_links\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cTG--tagWrapper eLB--modal__image\"],[12],[1,\"\\n        \"],[10,\"img\"],[14,0,\"o--media cDT--modal__media\"],[14,\"data-test-id\",\"image\"],[15,\"src\",[52,[30,2,[\"firstPostMediaItem\",\"previewUrl\"]],[30,2,[\"firstPostMediaItem\",\"previewUrl\"]],[30,0,[\"linkinbioPost\",\"highResOrProcessingUrl\"]]]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"editingLink\"]],[[[1,\"      \"],[10,0],[14,0,\"cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0\"],[12],[1,\"\\n        \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__tb__md cLB--header\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--m__r\"],[12],[1,\"\\n\"],[41,[30,0,[\"addNewLink\"]],[[[1,\"              \"],[8,[39,4],null,[[\"@onClick\",\"@variant\"],[[30,0,[\"cancelAddLink\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,5],[\"arrow-left\"],[[\"class\"],[\"o--icon--md o--icon--hl u--m__t__sm qa--linkinbio_left_arrow\"]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,4],null,[[\"@onClick\",\"@variant\"],[[30,0,[\"cancelEditLink\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,5],[\"arrow-left\"],[[\"class\"],[\"o--icon--md o--icon--hl u--m__t__sm qa--linkinbio_left_arrow\"]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"cLB--header__title\"],[12],[1,\"\\n\"],[1,\"            \"],[10,\"h4\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n\"],[41,[30,0,[\"addNewLink\"]],[[[1,\"                \"],[1,[28,[35,2],[\"linkinbio.multi_link.add_link\"],null]],[1,\"\\n\"]],[]],[[[1,\"                \"],[1,[28,[35,2],[\"linkinbio.multi_link.edit_link\"],null]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n\"],[1,\"            \"],[10,1],[14,0,\"cLB--header__subtitle u--text--sm u--m__t__0\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.adjust_location\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n        \"],[11,\"section\"],[24,0,\"o--modalBody--secondary has--footer\"],[4,[38,6],null,null],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.link_title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,7],[[24,0,\"o--form__input qa--linkinbio_text_input\"],[16,\"placeholder\",[28,[37,2],[\"linkinbio.multi_link.link_title\"],null]],[16,\"required\",true]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"selectedLink\",\"title\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.link_url\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,7],[[24,0,\"o--form__input qa--linkinbio_url_input\"],[24,\"data-test-id\",\"qa--linkinbio_url_input\"],[16,\"placeholder\",[28,[37,2],[\"linkinbio.multi_link.link_url\"],null]],[16,\"required\",true]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"selectedLink\",\"linkUrl\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"addNewLink\"]],[[[1,\"            \"],[11,\"button\"],[16,0,[29,[\"o--btn o--btn--outline o--btn--block qa--linkinbio_add_link\\n                \",[52,[30,0,[\"isValidMultiLink\"]],\"\",\"o--btn--disabled\"]]]],[24,4,\"button\"],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"commitPoint\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.save_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[11,\"button\"],[24,0,\"o--btn o--btn--mute u--float--left\"],[24,4,\"button\"],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"toggleDeleteLink\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.remove_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[11,\"button\"],[16,0,[29,[\"o--btn o--btn--outline u--float--right \",[52,[30,0,[\"isValidMultiLink\"]],\"\",\"o--btn--disabled\"]]]],[24,4,\"button\"],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"commitPoint\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"linkinbio.multi_link.update_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--modalHeader u--p__t__md u--hide--mobile\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title u--float--left\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"linkinbio.multi_link.external_links\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--hide--desktop\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--modalHeader u--p__t__md\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--text--bold\"],[12],[1,[28,[35,2],[\"post.body.manage_multi_links\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,10],null,[[\"@addLink\",\"@canAddNewLink\",\"@editLink\",\"@links\",\"@toggleDeleteLink\"],[[30,0,[\"addLink\"]],[30,0,[\"canAddNewLink\"]],[30,0,[\"editLink\"]],[30,0,[\"sortedLinks\"]],[30,0,[\"toggleDeleteLink\"]]]],null],[1,\"\\n\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,3],[[[1,\"            \"],[8,[39,4],[[24,0,\"qa--multiLink_saveBtn\"],[24,\"data-test-id\",\"multiLink-closeModalBtn\"]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"isLoading\"]],[30,0,[\"closeModalWithSave\"]],[28,[37,2],[\"shared_phrases.save_changes\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,4],[[24,0,\"qa--multiLink_doneBtn\"],[24,\"data-test-id\",\"multiLink-closeModalBtn\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,9],[[30,0,[\"closeModal\"]],false],null],[28,[37,2],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"@post\",\"@handleSave\"],false,[\"shared/modal\",\"did-insert\",\"t\",\"if\",\"shared/ui/button\",\"svg-jar\",\"perfect-scroll\",\"input\",\"on\",\"fn\",\"shared/linkinbio/list/multi-link\"]]",
    "moduleName": "shared/components/shared/linkinbio/modal/multi-link.hbs",
    "isStrictMode": false
  });
  let MultiLinkModalComponent = _exports.default = (_class = class MultiLinkModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "router", _descriptor3, this);
      _initializerDefineProperty(this, "store", _descriptor4, this);
      _defineProperty(this, "maxNumLinks", 5);
      _initializerDefineProperty(this, "addNewLink", _descriptor5, this);
      _initializerDefineProperty(this, "editingLink", _descriptor6, this);
      _initializerDefineProperty(this, "imageTag", _descriptor7, this);
      _initializerDefineProperty(this, "isLoading", _descriptor8, this);
      _initializerDefineProperty(this, "rollbackData", _descriptor9, this);
      _initializerDefineProperty(this, "savingPostLink", _descriptor10, this);
      _initializerDefineProperty(this, "selectedLink", _descriptor11, this);
    }
    get canAddNewLink() {
      return this.filteredLinks?.length < this.maxNumLinks;
    }
    get hasUnsavedLinks() {
      return this.linkinbioLinkList.any(link => link.get('hasDirtyAttributes'));
    }
    get isValidMultiLink() {
      return (0, _isValidUrl.isValidUrl)((0, _object.get)(this.selectedLink, 'linkUrl')) && (0, _utils.isPresent)((0, _object.get)(this.selectedLink, 'title')) && !this.savingPostLink;
    }
    get linkinbioLinkList() {
      return this.linkinbioPost.get('linkinbioPostLinks');
    }
    get linkinbioPost() {
      return this.args.linkinbioPost;
    }
    get filteredLinks() {
      return this.linkinbioLinkList.filter(link => !link.isDeleted);
    }
    get sortedLinks() {
      return this.filteredLinks.sort((linkA, linkB) => {
        const idA = linkA.id;
        const idB = linkB.id;
        if (!idA && !idB) {
          return linkA.createdTime - linkB.createdTime;
        }
        if (!idA) {
          return 1;
        }
        if (!idB) {
          return -1;
        }
        return idA - idB;
      });
    }
    addLink() {
      this.editingLink = true;
      this.addNewLink = true;
      this.selectedLink = {};
      this.imageTag.enableNewPoints();
      this.imageTag.newPoint();
    }
    cancelAddLink() {
      const point = this.imageTag.getPointById(this.selectedLink?.id);
      this.imageTag.removePoint(point);
      this.imageTag.disableNewPoints();
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {};
    }
    cancelEditLink() {
      this.editingLink = false;
      const link = this.selectedLink;
      const id = link.get('id') || link.get('createdAt');
      link.title = this.rollbackData?.title;
      link.linkUrl = this.rollbackData?.linkUrl;
      this.rollbackData = {};

      //Note: Rollback Changes to Point Position
      const point = this.imageTag.getPointById(id);
      this.imageTag.positionPoint(point, this.formatPoint(link));
      this.imageTag.saveAllPoints();
      this.imageTag.disableNewPoints();
    }
    clickOutside() {
      if (this.hasUnsavedLinks) {
        this.dialogManager.confirm(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        }).then(() => this.closeModal()).catch(() => {});
      } else {
        this.closeModal(Boolean(this.args.handleSave));
      }
    }
    closeModal() {
      let rollback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (rollback) {
        this.store.peekAll('linkinbio-post-link').filter(link => link.get('linkinbioPost.id') === this.linkinbioPost.get('id')).forEach(link => link.rollbackAttributes());
      }
      document.querySelector('.eLB--modal__image').removeEventListener('click', this.clickTagEventHandler);
      this.args.togglePostModal('multilink');
    }
    async closeModalWithSave() {
      this.isLoading = true;
      await this.args.handleSave.perform(this.linkinbioPost, () => {
        this.closeModal();
        this.isLoading = false;
      });
      if (!this.linkinbioPost.get('hasMultiLinks')) {
        this.router.transitionTo({
          queryParams: {
            tab: 'blocks',
            block: _linkinbioBlockTypes.default.FEED_LIST,
            blockId: null,
            postId: null,
            postType: null,
            feedType: null
          }
        });
      }
    }
    commitPoint(link) {
      const point = this.imageTag.getActivePoint();
      if (link.set) {
        link.set('x', point.x);
        link.set('y', point.y);
      } else {
        this.store.createRecord('linkinbio-post-link', {
          x: point.x,
          y: point.y,
          title: link.title,
          linkUrl: link.linkUrl,
          linkinbioPost: this.linkinbioPost,
          createdAt: Date.now()
        });
      }
      this.savingPostLink = false;
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {};

      // Temp fix: Re-seed after every save, to fix "id" no updating on new point save
      this.seedPoints();
      this.imageTag.disableNewPoints();
    }
    deletePostLink(link) {
      link.deleteRecord();
      this.seedPoints();
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {};
    }
    destroyPost() {
      this.store.peekAll('linkinbio-post-link').filter(link => link.get('linkinbioPost.id') === this.linkinbioPost.get('id')).forEach(link => {
        this.deletePostLink(link);
      });
      this.args.toggleTypeSelectorModal();
    }
    editLink(link) {
      this.editingLink = true;
      this.selectedLink = link;
      this.imageTag.enableNewPoints();
      this.rollbackData = {
        title: link.get('title'),
        linkUrl: link.get('linkUrl')
      };
      const id = link.get('id') || link.get('createdAt');
      const point = this.imageTag.getPointById(id);
      this.imageTag.setActivePoint(point);
    }
    setup() {
      this.initImageTag();

      // Go to create link view automatically
      if (this.sortedLinks.length === 0) {
        const img = document.querySelector('.eLB--modal__image img');
        const loadHandler = () => {
          if (this.isDestroying) {
            return;
          }
          this.addLink();
          this.selectedLink = {
            linkUrl: this.linkinbioPost.get('linkUrl'),
            title: ''
          };
          if (this.linkinbioPost.get('isNew')) {
            this.linkinbioPost.set('linkUrl', undefined);
          }
          img.removeEventListener('load', loadHandler);
        };
        img.addEventListener('load', loadHandler);
      }
      document.querySelector('.eLB--modal__image').addEventListener('click', this.clickTagEventHandler);
    }
    toggleDeleteLink(link) {
      this.selectedLink = link;
      this.dialogManager.confirm(this.intl.t('linkinbio.multi_link.confirm_delete'), {
        confirmButton: this.intl.t('shared_words.remove')
      }).then(() => this.deletePostLink(link));
    }
    clickTagEventHandler(event) {
      if (this.imageTag.getActivePoint()) {
        return;
      }
      const tag = this.findAncestor(event.target, 'cTG--tag');
      if (tag) {
        const tagId = tag.className.split(' ').find(classname => classname.includes('cTG--tag-')).replace('cTG--tag-', '');
        const link = this.store.peekAll('linkinbio-post-link').find(link => (0, _compareStrings.areStringsEqual)(link.id, tagId) || (0, _compareStrings.areStringsEqual)(link.createdAt, tagId));
        this.editLink(link);
      }
    }
    initImageTag() {
      this.imageTag = new _imageTag.default('.eLB--modal__image', {
        className: 'cTG--tag',
        pointTextClassName: 'cTG--tag__point',
        activeClassName: 'is--active'
      });
      this.seedPoints();
      this.imageTag.disableNewPoints();
    }
    seedPoints() {
      const seedData = this.sortedLinks.map((link, idx) => this.formatPoint(link, idx + 1));
      this.imageTag.seedPoints(seedData);
    }
    formatPoint(emberObject, text) {
      return {
        id: emberObject.get('id') || emberObject.get('createdAt'),
        // createdAt is used for unsaved/new links
        x: emberObject.get('x'),
        y: emberObject.get('y'),
        text
      };
    }
    findAncestor(el, cls) {
      let element = el;
      while ((element = element.parentElement) && !element.classList.contains(cls));
      return element;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addNewLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "editingLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "imageTag", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "rollbackData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "savingPostLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectedLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelAddLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelAddLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickOutside", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickOutside"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModalWithSave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModalWithSave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commitPoint", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "commitPoint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deletePostLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deletePostLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleDeleteLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDeleteLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickTagEventHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickTagEventHandler"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MultiLinkModalComponent);
});